import { DialogActions, DialogContent } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RemoveLocationPayload } from 'shared/store/useLocations/types'
import ContainedButton from 'shared/components/Buttons/ContainedButton'
import { useRemoveLocationMutation } from 'shared/store/useLocations'
import OutlinedButton from 'shared/components/Buttons/OutlinedButton'

interface Props {
   locationUuid?: string
   handleClose: () => void
}

export default function DeleteLocation({ locationUuid, handleClose }: Props) {
   const { t } = useTranslation(['TRANSLATION', 'LOCATIONS'])
   const { mutate, isLoading } = useRemoveLocationMutation()

   function deleteLocation() {
      const payload: RemoveLocationPayload = locationUuid ? { locationUuid } : {}
      mutate(payload, {
         onSettled: () => handleClose(),
      })
   }

   return (
      <>
         <DialogContent>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
               {t('LOCATIONS:deleteLocationText')}
            </Typography>
         </DialogContent>
         <DialogActions>
            <OutlinedButton isDelete onClick={handleClose} variant="outlined">
               {t('TRANSLATION:cancel')}
            </OutlinedButton>
            <ContainedButton isDelete disabled={isLoading} onClick={deleteLocation} variant="contained">
               {t('TRANSLATION:delete')}
            </ContainedButton>
         </DialogActions>
      </>
   )
}
